// extracted by mini-css-extract-plugin
export default {"sidePosterContainer":"Sidebar_sidePosterContainer__kCIDI","slideIn":"Sidebar_slideIn__ivRoF","posterContent":"Sidebar_posterContent__rSklG","closeBtn":"Sidebar_closeBtn__VU4S3"};